<script>
import { mapState, mapActions, mapGetters } from "vuex";

import paymentValidators from "@/utils/validators/payments";
import orderChannel from "../../channels/order";
import paymentsChannel from "../../channels/payments";

import CreditCard from "./PaymentOptions/CreditCard";
import Boleto from "./PaymentOptions/Boleto";
import AccountBalance from "./PaymentOptions/AccountBalance";
import Error from "./Components/Error";
import GifLoader from "./Components/GifLoader";

export default {
  components: {
    CreditCard,
    Boleto,
    AccountBalance,
    GifLoader,
    Error
  },

  methods: {
    ...mapActions("payable", ["setPaymentType"]),

    async selectPaymentType(type) {
      await this.setPaymentType(type);
    },

    labelDaysToPay() {
      return paymentValidators.labelDaysToPay();
    }
  },

  computed: {
    ...mapState("payable", ["preloaderPayment", "errorOnPayment"]),
    ...mapGetters("payable", [
      "isPaymentCreditCard",
      "isPaymentBoleto",
      "isPaymentAccountBalance",
      "canShowPayment",
      "canShowPaymentOptions",
      "cantPayWithBoleto",
      "canPayWithAccountBalance"
    ])
  },

  channels: {
    OrderChannel: orderChannel,
    PaymentChannel: paymentsChannel
  },

  mounted() {
    this.$cable.subscribe({ channel: "OrderChannel" });
    this.$cable.subscribe({ channel: "PaymentChannel" });
  }
};
</script>

<template>
  <transition name="down" mode="out-in">
    <div v-if="canShowPayment" class="card">
      <transition name="zoom" mode="out-in">
        <div v-if="errorOnPayment">
          <Error />
        </div>

        <GifLoader v-else-if="preloaderPayment" />

        <div v-else-if="canShowPaymentOptions">
          <h3>Escolha a sua forma de pagamento</h3>

          <div class="buttons">
            <button @click="selectPaymentType('STORED_CREDIT_CARD')">
              CARTÃO DE CRÉDITO
            </button>

            <button
              :disabled="cantPayWithBoleto"
              :class="{ 'button-disabled': cantPayWithBoleto }"
              @click="selectPaymentType('BOLETO')"
            >
              GERAR BOLETO/PIX
            </button>

            <!-- <button
              @click="selectPaymentType('BOLETO')"
            >
              GERAR BOLETO/PIX
            </button> -->

            <button
              v-if="canPayWithAccountBalance"
              @click="selectPaymentType('ACCOUNT_BALANCE')"
            >
              UTILIZAR SALDO
            </button>
          </div>

          <div class="warning" v-if="cantPayWithBoleto">
            Opção de boleto indisponível pois você selecionou uma limpeza com menos de {{ labelDaysToPay() }} de antecedência.
          </div>
        </div>        

        <CreditCard v-else-if="isPaymentCreditCard" />

        <Boleto v-else-if="isPaymentBoleto" />

        <AccountBalance v-else-if="isPaymentAccountBalance" />
      </transition>
    </div>
  </transition>
</template>

<style scoped>
.card {
  margin: 0;
  padding: 16px;
  transition-delay: 0.75s;
}

h3 {
  text-align: center;
  margin-top: 0;
  font-size: 16px;
  font-weight: 500;
}

.buttons {
  display: flex;
  flex-direction: column;
}

button {
  width: 100%;
  max-width: 100%;
  height: 44px;
  margin-top: 8px;
  border: 0;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #603285;
  border-radius: 4px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
}

button:hover {
  background-color: var(--pink-dark);
}

.button-disabled {
  opacity: 0.25;
  cursor: default;
}

.warning {
  margin-top: 12px;
  border-left: solid 1px #af006b;
  color: #af006b;
  padding-left: 8px;
  font-size: 12px;
}

@media (min-width: 480px) {
  .buttons {
    flex-direction: row;
  }

  button:not(:last-child) {
    margin-right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CheckoutMobile/Payment/Payment.vue